import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { ItemsearchcatComponent } from '../itemsearchcat/itemsearchcat.component';
import { TreatmentGroupHDModel } from 'src/app/models/TreatmentGroupHDModel';
import { TreatmentGroupHDService } from 'src/app/services/TreatmentGroupHDService';
import { TreatmentGroupHDDetModel } from 'src/app/models/TreatmentGroupHDDetModel';
import { TreatmentGroupDetService } from 'src/app/services/TreatmentGroupDetServic';
import { TreatmentGroupSearchComponent } from '../treatment-group-search/treatment-group-search.component';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';

@Component({
  selector: 'app-treatment-group',
  templateUrl: './treatment-group.component.html',
  styleUrls: ['./treatment-group.component.css']
})
export class TreatmentGroupComponent implements OnInit {

  // TreatmentGroup Head
  tgcode = '';
  tgname = '';

  // items Search
  itCode = '';
  itTName = '';
  itGName = '';
  itAName = '';
  itClass = '';
  itUnit = '';
  iTPurchasis = '0';
  iTMedical = '0';
  iTMegor = '';
  iTStore = '';
  itGrouping = '';


  // drug TreatmentGroups items
  tgdetcategory = '';
  tgdetitcode = '';
  tgdetitname = '';
  tgdetunit = '';
  tgdetdose = '';
  tgdetqty = '';
  tgdetrote = '';
  tgdetduration = '';
  tgdetnotes = '';

  items: '';
  drgserial: '';
  drgName: '';

  // Labs Data




  compcode = '1';
  userid = '';
  modifieddate = '';
  unitsList :UnitsModel []=[];
  unName =[];
  DrugTreatmentGroupDet: TreatmentGroupHDDetModel[] = [];
  DrugGroup: TreatmentGroupHDDetModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();



  constructor(
    public TreatmentGroupHDService: TreatmentGroupHDService,
    public TreatmentGroupDet: TreatmentGroupHDDetModel,
    public TreatmentGroupHD: TreatmentGroupHDModel,
    public TreatmentGroupHDSelectedData: TreatmentGroupHDModel,
    public DrugTreatmentGroupDetSelectedData: TreatmentGroupHDDetModel,
    public itemsSelectedData: ItemsModel,
    public itemsService: ItemsService,
    public unitsService : UnitsService,
    public storage: LocalStorageService,
    public TreatmentGroupDetService: TreatmentGroupDetService,
    private dialogref: MatDialog,
  ) { }

  ngOnInit(): void {
   this.retriveUnitsLookupTop();
    /// this.retriveTreatmentGroupDetTop();
  }
  // TreatmentGroup Head data
  retriveTreatmentGroupHD() {
    this.TreatmentGroupHDService.getTreatmentGroupHD(this.tgcode, this.compcode).subscribe((data: TreatmentGroupHDModel) => {
      this.tgname = data.tgname;
      this.compcode = data.compcode;
      this.userid = data.compcode;

      this.retriveTreatmentGroupDetTop()
    });
  }

  TreatmentGroupDetEdit(det: TreatmentGroupHDDetModel) {
    this.tgcode = det.tgcode
    this.tgdetitcode = det.tgdetitcode
    this.tgdetitname = det.tgdetitname
    this.tgdetdose = det.tgdetdose
    this.tgdetqty = det.tgdetqty
    this.tgdetrote = det.tgdetrote
    this.tgdetduration = det.tgdetduration
    this.tgdetnotes = det.tgdetnotes
    this.retriveTreatmentGroupDetTop()
  }


  retriveTreatmentGroupDetTop() {
    this.DrugGroup = [];
    this.TreatmentGroupDetService.GetTreatmentGroupDet(this.tgcode, this.storage.retrieve('stgcompCode')).subscribe((data: TreatmentGroupHDDetModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.DrugGroup[i] = data[i];
        this.DrugGroup[i].tgcode = data[i].tgcode
        this.DrugGroup[i].tgdetitcode = data[i].tgdetitcode
        this.DrugGroup[i].tgdetitname = data[i].tgdetitname
        this.DrugGroup[i].tgdetdose = data[i].tgdetdose
        this.DrugGroup[i].tgdetqty = data[i].tgdetqty
        this.unitsService.getUnits(data[i].tgdetqty, this.storage.retrieve('stgcompCode')).subscribe((data: UnitsModel) => {
        this.unName[i] = data.unName;

    }
    );
        this.DrugGroup[i].tgdetrote = data[i].tgdetrote
        this.DrugGroup[i].tgdetduration = data[i].tgdetduration
        this.DrugGroup[i].tgdetnotes = data[i].tgdetnotes
      }



    });

  }

  DeleteTreatmentGroup() {
    this.TreatmentGroupHDService.DeleteTreatmentGroupHD(this.tgcode, this.storage.retrieve('stgcompCode')).subscribe((data: TreatmentGroupHDModel) => {
      this.tgname = data.tgname;
      this.compcode = data.compcode;
      this.userid = data.compcode;
    });
  }

  NewData() {
    this.tgcode = '';
    this.tgname = '';
    this.userid = this.storage.retrieve('stguserId');
    this.compcode = '1';
    this.DrugGroup = [];
  }

  submitTreatmentGroup() {
    this.TreatmentGroupHD.tgcode = this.tgcode;
    this.TreatmentGroupHD.tgname = this.tgname;
    this.TreatmentGroupHD.userid = this.storage.retrieve('stguserId');
    this.TreatmentGroupHD.compcode = this.storage.retrieve('stgcompCode');
    this.TreatmentGroupHDService.AddTreatmentGroupHD(this.TreatmentGroupHD).subscribe(
      (data) => {
        this.mesgSave();
        this.NewData();
      },
      (error) => {
        alert(error);
      }
    );
  }


  mesgDelete() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {

      this.DeleteTreatmentGroup();
      this.DeleteTreatmentGroupDet();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,
      timer: 1500
    });
  }
  TreatmentGroupSearch(): void {
    const dialogRef = this.dialogref.open(TreatmentGroupSearchComponent,
      {
        data: {
          dataKey: this.TreatmentGroupHDSelectedData
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.tgcode = result.tgcode;
        this.retriveTreatmentGroupHD();
        dialogSubmitSubscription.unsubscribe();
      });


  }

     retriveUnitsLookupTop() {
      this.unitsService.getUnitsLookupTop(this.storage.retrieve('stgcompCode'))
        .subscribe((data: UnitsModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.unitsList[i] = data[i];
          }

        });
    }


  openDialog() {
    const dialogRef = this.dialogref.open(ItemsearchcatComponent,
      {
        data: {
          dataKey: this.items,
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.tgdetitcode = result.itCode;
        this.tgdetitname = result.itTName;

        dialogSubmitSubscription.unsubscribe();
      });


  }

  MedNewData() {
    this.tgdetitcode = '';
    this.tgdetitname = '';
    this.tgdetdose = '';
    this.tgdetqty = '';
    this.tgdetrote = '';
    this.tgdetduration = '';
    this.tgdetnotes = '';
    this.userid = this.storage.retrieve('stguserId');
    this.compcode = '1';
  }

  submitMed() {
    if(this.tgcode == '' || this.tgcode == null){return};
    this.TreatmentGroupDet.tgcode = this.tgcode;
    this.TreatmentGroupDet.tgdetitcode = this.tgdetitcode;
    this.TreatmentGroupDet.tgdetitname = this.tgdetitname;
    this.TreatmentGroupDet.tgdetdose = this.tgdetdose;
    this.TreatmentGroupDet.tgdetrote = this.tgdetrote;
    this.TreatmentGroupDet.tgdetqty = this.tgdetqty;
    this.TreatmentGroupDet.tgdetduration = this.tgdetduration;
    this.TreatmentGroupDet.tgdetnotes = this.tgdetnotes;
    this.TreatmentGroupDet.userid = this.storage.retrieve('stguserId');
    this.TreatmentGroupDet.compcode = this.storage.retrieve('stgcompCode');
    this.TreatmentGroupDetService.AddTreatmentGroupDet(this.TreatmentGroupDet).subscribe(
      (data) => {
        this.mesgSave();
        this.MedNewData();
        this.retriveTreatmentGroupDetTop();
      },
      (error) => {
        alert(error);
      }

    );

  }

    DeleteTreatmentGroupDet() {
    this.TreatmentGroupDetService.deleteTreatmentGroupDet(this.tgcode, this.tgdetitcode).subscribe((data: TreatmentGroupHDDetModel) => {

    });
    this.retriveTreatmentGroupDetTop();
  }
  mesgDeleteDet() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {

      this.DeleteTreatmentGroupDet();

      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
    retriveItems(){
    this.itemsService.getitems(this.itCode,this.compcode).subscribe((data: ItemsModel) => {
      this.tgdetitcode = data.itCode;
      this.tgdetitname = data.itTName;
      this.itGName = data.itGName;
      this.itAName = data.itAName;
      this.itClass = data.itClass;
      this.itUnit = data.itUnit;


    })
}
}

